<template>
	<div id="edcSystemApp-frame">
		<p class="txt-list-title">Proejct List</p>
		<div class="list-control-wrap">
			<input
				type="text"
				class="input-list-search"
				placeholder="Please enter the project name to search."
				v-model="searchText"
				@keyup="keyupHandler"
				@focus="infoBalloon"
				@blur="infoBalloon"
			/>
			<div v-if="isTyping" ref="typingBalloon" class="project-in-balloon">
				<p>Please press the Enter key. </p>
			</div>
		</div>
		<table class="tb-list-vertical tb-setting-list">
			<colgroup>
				<col width="5%" />
				<col width="30%" />
				<col width="15%" />
				<col width="15%" />
				<col width="25%" />
				<!-- <col width="10%" /> -->
			</colgroup>
			<thead>
				<tr>
					<th>No</th>
					<th>Name</th>
					<th>Version</th>
					<th>Case</th>
					<th>Function</th>
					<!-- <th>Remove</th> -->
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item) in projectList" :key="item.proejectNo" tabindex="0" @click.stop="doEdit(site)">
					<td>
						{{ item.rowNumber}}
					</td>
					<td class="ellipsis underline" :title="'['+item.projectName+']'+item.projectStudyTitle">
						[{{ item.protocolName }}] {{ item.projectStudyTitle }}
					</td>
					<td>
						V{{ item.projectVersion }}
					</td>
					<td class="ellipsis">
						{{ item.caseCount }} case
					</td>
					<td>
						<button
							type="button"
							class="btn-table"
							@click.stop="doDataCheck(item.projectNo)"
						>Data Download</button>
					</td>
				</tr>
				<tr v-if="projectList.length == 0">
					<td colspan="5" class="no-list">There is no registered site, Please register the site.</td>
				</tr>
			</tbody>
		</table>
		<div class="pagination-wrap">
			<pagination :data="pagination" :show-disabled="true" :limit="4" @pagination-change-page="doSearchPage">
				<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
				<button type="button" slot="next-nav" class="page-next">&gt;</button>
			</pagination>
		</div>
		<ProjectDataCreate v-if="isDataCreate" :projectNo="openProjectIndex"/>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import ProjectDataCreate from "@/components/project/project/ProjectDataCreate.vue"

export default {
	name: "CsemoList",
	props: {},
	components: {
		ProjectDataCreate,
	},
	beforeCreate(){
		let item = {
			userId: sessionStorage.getItem("userId"),
			privilegeTypeCd: "1",
			privilegeCategory: "SETTING",
			privilegeName: "ACCESS"
		}
		this.$accessAuth(item).then((status) => {
			if(status == false){
				this.$router.go(-1);
				this.$alert("You are not authorized.","Warning","warning");
			}
		})
	},
	created() {
		this.logger.debug(this, "created()");
		this.selectProjectList();
		this.selectProjectStateList();
		this.getAccessList('PROJECT');
		EventBus.$emit("setting-loading", false);
	},
	data() {
		return {
			item: {},
			siteList: [],
			pagination: {},
			searchText: "",
			isEdit: false,
			selectSiteCode: "",
			isTyping: false,
			projectList: [],
			projectStateList: [],
			openProjectIndex: -1,
			openPage: 1,
			isCreate: false,
			isData: false,
			isDataCreate: false,
			isTestDataCreate: false,
			openInfoBallon: -1,
			openDataBallon: -1,
			openVersionBallon: -1,
			projectImport: {},
			dataImport: {},
			isCopy: false,
			isMigration: false,
			accessList: [],
			isAccessCreate: false,
			isAccessImport: false,
			isMethod: false,
			isDataExportOpen: false,
		};
	},
	watch: {
		searchText: function(val) {
			this.item.searchText = val;
			this.item.pageNum = 1;
		}
	},
	methods: {
		keyupHandler(event) {
			this.logger.debug(this, "keyupHandler(event)");
			// this.searchTextVal = event.target.value;
			if (event.keyCode == 13)
			{
				EventBus.$emit("setting-loading", true);
				this.projectList = new Array();
				this.selectProjectList();
			}
		},
		infoBalloon(event) {
			this.logger.debug(this, "infoBalloon(event)");
			if(event.type == "focus")
			{
				this.isTyping = true;
			}
			else
			{
				this.$refs.typingBalloon.style.animation = "hideBalloon 0.3s ease-out both";
				setTimeout(function() {
					this.$refs.typingBalloon.style.animation = "";
					this.isTyping = false;
				}.bind(this), 310);
			}
		},
		doSearchPage(page) {
			this.logger.debug(this, "doSearchPage()");
			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.item.pageNum = page;
			this.selectProjectList();
		},
		selectProjectList() {
			this.logger.debug(this, "selectProjectList()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/project/selectCsemoList.do", this.item)
				.then((response) => {
					console.log(response);
					this.projectList = response.data.projectList;
					this.pagination = response.data.pagination;
					// for(var i = 0; i < response.data.projectList.length; i++){
					// 	if(response.data.projectList[i].projectVersion == 1 || response.data.projectList[i].ctcProjectNo != ''){
					// 		this.projectList.push(response.data.projectList[i]);
					// 	}
					// }
					this.$nextTick(function () {
						setTimeout(function() {
							// 로딩바 닫기 요청
							EventBus.$emit("setting-loading", false);
						}.bind(this), 400);
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectStateList() {
			this.logger.debug(this, "selectStateList()");
			console.log("백엔드로 보내는 데이터:", this.item);
			this.openProjectIndex = -1;
			this.$set(this.item, "searchText", this.searchText);
			axios
				.post(this.config.contextRoot + "/project/selectStateList.do", this.item)
				.then((response) => {
					console.log(response);
					this.projectList = response.data.projectList;
					this.$nextTick(function () {
						setTimeout(function() {
							// 로딩바 닫기 요청
							EventBus.$emit("setting-loading", false);
						}.bind(this), 400);
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectProjectStateList() {
			this.logger.debug(this, "selectProjectStateList()");
			axios
				.post(this.config.contextRoot + "/common/code/selectComCodeList.do", {classCode: "PROJECT_STATE"})
				.then((response) => {
					console.log(response);
					this.projectStateList = response.data.codeList;
					EventBus.$emit("setting-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCreate() {
			this.logger.debug(this, "doCreate()");
			this.isCreate = true;
		},
		openProject(event, index) {
			this.logger.debug(this, "openProject(event, index)");
			// 다른 Notice 클릭
			if(index != this.openProjectIndex) {
				// 이전 Notice Height 원상복귀
				if(this.openProjectIndex != -1) this.initHeight();
				if(this.openInfo != -1) this.openInfo = -1;
				// Open Index 설정
				this.openProjectIndex = index;
				// 전체 Height 적용
				let getPath = this.utils.getEventPath(event);
				let parentIndex = getPath.map(
					(item) => {
						return item.className;
					}
				).indexOf("box-project");
				let totalHeight = getPath[parentIndex].children[1].clientHeight + 130;
				totalHeight = (totalHeight <= 190 ? 190 : totalHeight);
				getPath[parentIndex].style.transition = "height 0.3s ease-in-out";
				getPath[parentIndex].style.height = totalHeight + "px";
				getPath[parentIndex].blur();
			}
		},
		initHeight() {
			this.logger.debug(this, "initHeight()");
			let projectLength = this.$refs.projectList.children.length;
			for(let i = 0 ; i < projectLength ; i++)
			{
				this.$refs.projectList.children[i].children[1].style.transition = "";
				this.$refs.projectList.children[i].children[1].style.height = "";
			}
		},
		moreView(event) {
			this.logger.debug(this, "moreView(event)");
			event.target.blur();
			if(this.openPage < this.maxPage) this.openPage++;
		},
		doEdit() {
			this.logger.debug(this, "doEdit()");
			this.isEdit = true;
		},
		dropBalloon(event, index, type) {
			this.logger.debug(this, "dropBalloon(event, index, type)");
			if(type == "info")
			{
				this.openInfoBallon = index - 1;
				this.openDataBallon = -1;
				this.openVersionBallon = -1;
			}
			else if(type == "version"){
				this.openInfoBallon = -1;
				this.openDataBallon = -1;
				this.openVersionBallon = index - 1;
			}
			else
			{
				this.openInfoBallon = -1;
				this.openDataBallon = index - 1;
				this.openVersionBallon = -1;
			}
			this.$nextTick(function () {
				if(type != 'version'){
					let childrenList = event.target.parentElement.children;
					console.log(childrenList);
					let index = (type == "info" ? 1 : 2);
					childrenList[index].style.top = (event.clientY - event.offsetY - 4) + "px";
					childrenList[index].style.left = (event.clientX - event.offsetX - 140) + "px";
					childrenList[index].focus();
				}
				else{
					let childrenList = event.target.parentElement.children;
					childrenList[1].style.top = (event.clientY - event.offsetY - 7) + "px";
					childrenList[1].style.left = (event.clientX - event.offsetX - 69) + "px";
					childrenList[1].focus();
				}
			});
		},
		hideBalloon(event, type) {
			this.logger.debug(this, "hideBalloon(event, type)");
			event.target.style.animation = "hideBalloon 0.3s ease-out both";
			if(type == "info")
			{
				setTimeout(function() {
					this.openInfoBallon = -1;
				}.bind(this), 310);
			}
			else if(type == "version"){
				setTimeout(function() {
					this.openVersionBallon = -1;
				}.bind(this), 310);
			}
			else
			{
				setTimeout(function() {
					this.openDataBallon = -1;
				}.bind(this), 310);
			}
		},
		doDownload(data) {
			this.logger.debug(this, "doDownload(data)");

			const formData = new FormData();
			formData.append("fileNo", data.fileNo);
			formData.append("fileName", data.fileName);
			formData.append("serverFileSaveName", data.serverFileSaveName);

			axios
				.post(this.config.contextRoot + "/common/file/download.do", formData, {responseType: "blob"})
				.then((response) => {
					console.log(response);
					const url = window.URL.createObjectURL(
						new Blob([response.data], {type: response.headers["content-type"]})
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", data.fileName);
					document.body.appendChild(link);
					link.click();
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doSiteDownload(data) {
			this.logger.debug(this, "doDownload(data)");

			const formData = new FormData();
			formData.append("siteFileNo", data.fileNo);
			formData.append("fileName", data.fileName);
			formData.append("serverFileSaveName", data.serverFileSaveName);

			axios
				.post(this.config.contextRoot + "/site/file/download.do", formData, {responseType: "blob"})
				.then((response) => {
					console.log(response);
					const url = window.URL.createObjectURL(
						new Blob([response.data], {type: response.headers["content-type"]})
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", data.fileName);
					document.body.appendChild(link);
					link.click();
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		openUploader(refName, projectNo) {
			this.logger.debug(this, "openUploader()");
			if(refName == 'DataUploader')
			{
				this.dataImport.projectNo = projectNo;
			}
			this.$refs[refName].openUploader();
		},
		exportProject(projectNo) {
			this.logger.debug(this, "exportProject(projectNo)");
			EventBus.$emit("project-loading", true);
			axios
				.post(this.config.contextRoot + "/project/transfer/exportProject.do", {projectNo: projectNo})
				.then((response) => {
					console.log(response);
					this.doDownload(response.data);
					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		importProject() {
			this.logger.debug(this, "importProject()");
			this.$confirm("Do you want to import the project?","Question","question").then(() => {
				EventBus.$emit("project-loading", true);
				axios
					.post(this.config.contextRoot + "/project/transfer/importProject.do", this.projectImport)
					.then(() => {
						this.$alert("The project has been successfully imported.","Success","success").then(() => {
							location.reload();
						});
					})
					.catch((error) => {
						this.exceptionHandler(this, error);
						location.reload();
					});
			});
		},
		importData(isAdd) {
			this.logger.debug(this, "importData()");
			this.isMethod = false;
			this.$confirm("Do you want to import project data?","Question","question").then(() => {
				EventBus.$emit("project-loading", true);
				this.dataImport.isAdd = isAdd;
				axios
					.post(this.config.contextRoot + "/project/transfer/importData.do", this.dataImport)
					.then((response) => {
							let result = response.data.result;
							if(result == "success")
							{
								this.$alert("The data has been successfully imported.","Success","success").then(() => {
									location.reload();
								});
							}
							else
							{
								this.$alert("They are different projects or the versions do not match.","Warning","warning").then(() => {
									location.reload();
								});
							}
					})
					.catch((error) => {
						this.exceptionHandler(this, error);
						location.reload();
					});
			});
		},
		exportDataOpen(){
			this.logger.debug(this, "exportDataOpen()");
			this.isDataExportOpen = true;
		},
		doProject(projectNo, ctcProjectNo) {
			this.logger.debug(this, "doProject(projectNo)");
			//Project 내의 Access 허용 여부 Check
			axios
				.post(this.config.contextRoot + "/access/selectProjectAccessUrl.do", {projectNo : projectNo, userId : sessionStorage.getItem("userId")})
				.then((response) => {
					console.log(response.data.url);
					if(response.data.url == 'false'){
						this.$alert("You are not authorized.","Warning","warning");
					}
					else{
						// this.$alert(window.location.href ,"Warning","warning");
						let url = this.config.contextRoot + "/project/" + projectNo + this.getProjectName(response.data.url);
						if (this.$route.path !== url)
						{
							EventBus.$emit("project-loading", true);
							// this.$router.push(url);
							location.href = window.location.href + "/" + projectNo + this.getProjectName(response.data.url);
							this.$set(this.$route.params, "ctcProjectNo", ctcProjectNo);
						}
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		getProjectName(obj){
			let url = "";

			if(obj == 'PAGE'){
				url = "/page";
			}
			else if(obj == 'DICTIONARY'){
				url = "/projectDictionary"
			}
			else if(obj == 'VISIT'){
				url = "/visit"
			}
			else if(obj == 'SCHEDULE'){
				url = "/schedule"
			}
			else if(obj == 'VALIDATION'){
				url = "/validation"
			}
			else if(obj == 'CALCULATION'){
				url = "/calculation"
			}
			else if(obj == 'SCREENING'){
				url = "/screening"
			}
			else if(obj == 'TEST SCREENING'){
				url = "/testScreening"
			}
			else if(obj == 'ENTRY'){
				url = "/screening"
			}
			else if(obj == 'TEST ENTRY'){
				url = "/testScreening"
			}
			else if(obj == 'QUERY RESOLUTION'){
				url = "/queryResolution"
			}
			else if(obj == 'TEST QUERY RESOLUTION'){
				url = "/testQueryResolution"
			}
			else if(obj == 'ROLE'){
				url = "/role"
			}
			else if(obj == 'USER'){
				url = "/user"
			}
			else if(obj == 'SITE'){
				url = "/site"
			}

			return url;
		},
        doDataCheck(projectNo) {
			this.logger.debug(this, "doDataCheck(projectNo)");
			this.openProjectIndex = projectNo;
			axios
				.post(this.config.contextRoot + "/excel/selectProcExist.do", {projectNo : projectNo})
				.then((response) => {
					console.log(response);
					if(response.data.procCount > 0)
					{
						this.doDataCreate();
					}else{
						this.$alert("There's No Survey to Download in this Project.","Warning","warning");
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doDataCreate(){
			this.logger.debug(this, "doDataCreate()");
			this.isDataCreate = true;
		},
        doTestDataCheck(projectNo) {
			this.logger.debug(this, "doTestDataCheck(projectNo)");
			axios
				.post(this.config.contextRoot + "/excel/selectProcExist.do", {projectNo : projectNo})
				.then((response) => {
					console.log(response);
					if(response.data.procCount > 0)
					{
						this.doTestDataCreate();
					}else{
						this.$alert("There's No Survey to Download in this Project.","Warning","warning");
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doTestDataCreate(){
			this.logger.debug(this, "doTestDataCreate()");
			this.isTestDataCreate = true;
		},
		copyProject(projectNo)
		{
			this.logger.debug(this, "copyProject()");
			this.copyProjectNo =  projectNo;
			this.isCopy = true;
		},
		migrationOpen(projectNo)
		{
			this.logger.debug(this, "migrationOpen()");
			this.copyProjectNo =  projectNo;
			this.isMigration = true;
		},
		// createVersion(projectNo){
		// 	this.logger.debug(this, "createVersion(projectNo)");
		// 	console.log(projectNo);
		// 	this.$confirm("Do you want to create a new version?", "Question", "question").then(() => {
		// 					EventBus.$emit("field-loading", true);
		// 					this.doCopy(projectNo);
		// 				});
		// },
		versionChange(project, version, event){
			let versionList = JSON.parse(JSON.stringify(project.projectVersionList));
			let projectCopy;
			let pindex;
			this.projectList.forEach((item, index) => {
				if(item.projectNo == project.projectNo){
					pindex = index;
				}
			})
			this.projectList[pindex].projectVersionList.forEach((item) => {
				if(item.projectVersion == version){
					item.projectVersionList = versionList;
					projectCopy = JSON.parse(JSON.stringify(item));
				}
			})

			this.$set(this.projectList, pindex, projectCopy);
			
			event.target.parentElement.style.animation = "hideBalloon 0.3s ease-out both";
			setTimeout(function() {
				this.openVersionBallon = -1;
			}.bind(this), 310);
		},
		// doCopy(projectNo) {
        //     axios
		// 		.post(this.config.contextRoot + "/project/projectVersion.do", {projectNo: projectNo})
		// 		.then((response) => {
		// 			console.log(response);

		// 			this.$alert("The new version has been successfully created.", "Info", "info").then(() => {
		// 				location.reload();
		// 			});
		// 		})
		// 		.catch((error) => {
		// 			this.exceptionHandler(this, error);
		// 		})
		// },
		selectValue(value, target, bools) {
			this.$set(this.item, target, value);
			if(target == 'searchStateCd' || target == 'searchCtcStateCd')
			{
				if(bools == true)
				{
					this.isData = false;
				}
				else
				{
					this.isData = true;
					if(value == "0") {
						this.selectProjectList();
					}
					else{
						this.selectStateList();
					}
				}
			}
		},
		getAccessList(category){
			axios
				.post(this.config.contextRoot + "/access/getCategoryPrivilegeList.do", {privilegeCategory: category})
				.then((response) => {
					console.log(response);
					this.accessList = response.data.privilegeList;
					this.accessList.forEach((obj) =>{
						this.workCheck(obj);
					})
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		async workCheck(obj){
			let item = {};
			item = {
				userId: sessionStorage.getItem("userId"),
				privilegeTypeCd: obj.privilegeTypeCd,
				privilegeCategory: obj.privilegeCategory,
				privilegeName: obj.privilegeName
			}
			obj.isAccess = await this.$accessAuth(item);
			if(obj.privilegeName == 'CREATE' && obj.isAccess == true){
				this.isAccessCreate = true;
			}
			if(obj.privilegeName == 'IMPORT' && obj.isAccess == true){
				this.isAccessImport = true;
			}
		},
		workAccessCheck(name){
			for(let  i = 0; i < this.accessList.length; i++){
				if(this.accessList[i].privilegeName == name){
					return this.accessList[i].isAccess;
				}
			}
		},
		cancelData() {
			this.isMethod = false;
			this.dataImport = {};
		},
		privilegeUpdate(){
			axios
				.post(this.config.contextRoot + "/project/privilegeUpdate.do", this.item)
				.then((response) => {
					console.log(response);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
	}
};
</script>import { iterator } from "core-js/fn/symbol";

